<template>
    <div class="layout-comment-form layout-comment-form-edit">
        <van-collapse class="layout-comment-collapse" v-model="activeNames" v-bind:border="false">
            <!-- 1、命盘特点、性格、六亲关系及运势等整体分析 -->
            <van-collapse-item class="layout-cc-item" v-bind:border="false" name="base" v-if="pipanInfoBase && pipanInfoBase.base">
                <div class="layout-cc-title" slot="title">命盘特点、性格、六亲关系及运势等整体分析 </div>
                <div class="layout-cc-content">
                    <!-- 编辑状态 -->
                    <comment-edit-panel
                        v-bind:fromPage="'commentForm'"
                        v-bind:textValue="pipanInfoBase.base"
                        v-bind:textId="'base'"
                        v-bind:saveFunc="clickSaveBase">
                    </comment-edit-panel>
                </div>
            </van-collapse-item>
            <!-- 2、命局类型及强弱判断 -->
            <van-collapse-item class="layout-cc-item" v-bind:border="false" name="situation">
                <div class="layout-cc-title" slot="title">命局类型及强弱判断</div>
                <div class="layout-cc-content pdt-none">
                    <div class="layout-ccc-line dsp-flex">
                        <div class="layout-ccc-label"><span>命局类型</span></div>
                        <div class="layout-ccc-note" v-if="canBeEdited" @click="clickChange('situation')"><span>{{situationText}}</span><i class="iconfont icon-down"></i></div>
                    </div>
                    <div class="layout-ccc-line dsp-flex">
                        <div class="layout-ccc-label"><span>命局强弱</span></div>
                        <div class="layout-ccc-note" @click="clickChange('strong')"><span>{{strongText}}</span><i class="iconfont icon-down"></i></div>
                    </div>
                </div>
            </van-collapse-item>
            <!-- 3、命局用神(或病药)分析 -->
            <van-collapse-item class="layout-cc-item" v-bind:border="false" name="medicine">
                <div class="layout-cc-title" slot="title">命局用神(或病药)分析</div>
                <!-- 编辑状态 -->
                <div class="layout-cc-content pdt-none">
                    <comment-medicine-item
                        v-for="medicineData of medicineList"
                        v-bind:key="'medicine' + medicineData.id + Math.random(0, 10)"
                        v-bind:medicineData="medicineData"
                        v-bind:itemFunc="clickChange"
                        v-bind:saveFunc="clickSaveMedicine"
                        v-bind:subFunc="clickSubMedicine"
                        v-bind:plusFunc="clickPlusMedicine">
                    </comment-medicine-item>
                </div>
            </van-collapse-item>
            <!-- 4、大运流年详细分析 -->
            <van-collapse-item id='dayunliunian' class="layout-cc-item" v-bind:border="false" name="big">
                <div class="layout-cc-title" slot="title">大运流年详细分析</div>
                <p>前往最新版本APP操作更新批盘</p>
                <!-- <comment-list></comment-list> -->
            </van-collapse-item>
            <!-- 5、其他分析 -->
            <van-collapse-item class="layout-cc-item" v-bind:border="false" name="other" v-if="pipanInfoBase && pipanInfoBase.other">
                <div class="layout-cc-title" slot="title">其他分析</div>
                <div class="layout-cc-content">
                    <comment-edit-panel
                        v-bind:fromPage="'commentForm'"
                        v-bind:textValue="pipanInfoBase.other"
                        v-bind:textId="'other'"
                        v-bind:saveFunc="clickSaveOther">
                    </comment-edit-panel>
                </div>
            </van-collapse-item>
            <!-- 6、注意事项及建议 -->
            <van-collapse-item class="layout-cc-item" v-bind:border="false" name="suggest" v-if="pipanInfoBase && pipanInfoBase.other">
                <div class="layout-cc-title" slot="title">注意事项及建议</div>
                <div class="layout-cc-content">
                    <comment-edit-panel
                        v-bind:fromPage="'commentForm'"
                        v-bind:textValue="pipanInfoBase.suggest"
                        v-bind:textId="'suggest'"
                        v-bind:saveFunc="clickSaveSuggest">
                    </comment-edit-panel>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>

<script>
import CommentEditPanel from './CommentEditPanel.vue'
import CommentList from './CommentList.vue'
import CommentMedicineItem from './CommentMedicineItem.vue'
import { UTILS } from '../../modules/utils';
export default {
    name: 'CommentForm',
    components: {CommentEditPanel, CommentList, CommentMedicineItem},
    computed: {
        canBeEdited() {
            return this.$store.state.comment.canBeEdited;
        },
        detailInfo() {
            return this.$store.state.comment.detailInfo;
        },
        pipanInfoBase() {
            return this.$store.state.comment.pipanInfoBase;
        },
        situationText() {
            return this.$store.state.comment.situationText;
        },
        strongText() {
            return this.$store.state.comment.strongText;
        },
        medicineList() {
            return this.$store.state.comment.medicineList;
        },
        activeNames: {
            get() {
                return this.$store.state.comment.activeNames;
            },
            set(value) {
                this.$store.state.comment.activeNames = value;
            }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            medicineInput: {}
        }
    },
    methods: {
        // 保存命盘特点、性格
        clickSaveBase(text, parentData, cb) {
            var params = { info: { base: text }, cb: cb };
            this.$store.dispatch('comment/updatePiPan', params);
        },
        // 保存其他分析
        clickSaveOther(text, parentData, cb) {
            var params = { info: { other: text }, cb: cb };
            this.$store.dispatch('comment/updatePiPan', params);
        },
        // 保存建议
        clickSaveSuggest(text, parentData, cb) {
            var params = { info: { suggest: text }, cb: cb };
            this.$store.dispatch('comment/updatePiPan', params);
        },
        // 点击修改命局，强弱，药(类型)
        clickChange(type, itemData = {}) {
            if(type == 'medicine'){
                this.$store.state.comment.curMedicineItem = itemData;
            }
            this.$store.state.comment.showChange = true;
            this.$store.state.comment.curChangeType = type;
            this.$store.dispatch('comment/updateCommentChangeList', type);
        },
        clickSaveMedicine(text, medicineData) {
            this.$store.state.comment.curMedicineItem = medicineData;
            var params = {medicineContent: text};
            this.$store.dispatch('comment/updatePiPanMedicine', params);
        },
        clickSubMedicine(medicineData) {
            this.$store.dispatch('comment/deletePiPanMedicine', medicineData);
        },
        clickPlusMedicine(medicineData) {
            this.$store.dispatch('comment/addPiPanMedicine', medicineData);
        }
    }
}
</script>